export default "__VITE_ASSET__CZOBQA1W__"